
import { jwtDecode } from 'jwt-decode';
import { message } from 'antd'

export const USER_LOGGED = 'USER_LOGGED'
export const AUTH_ERROR = 'AUTH_ERROR'
export const UNAUTORIZED_ACCES = 'UNAUTORIZED_ACCES'
export const DISCONNECT = 'DISCONNECT'
export const SET_ACTIVE_CLIENT = 'SET_ACTIVE_CLIENT'


export const logout = () => (dispatch) => {
  dispatch(disconnect())
}

export const login = (user) => (dispatch, getState) => {
  const initialized = getState().server.initialized;
  const url = getState().server.authUrl + '/LoginClient';

  if (initialized) {
    return fetch(url, {
      method: 'post',
      body: JSON.stringify(user),
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => {
        if (response.status === 200)
          return response.json()
        if (response.status === 401 || response.status === 403 || response.status === 500) {
          message.info('les paramètres d\'identifications sont incorrects', 5)
          dispatch(unauthorizedAccess())
          throw new Error('handled')
        }
      })
      .then(json => {
        if (json.token === undefined || json.clients.length === 0) {
          dispatch(disconnect())
        } else {
          let token = json.token;
          let clients = json.clients;


          dispatch(userLoggedIn(token, clients));

        }
      })
      .catch((error) => dispatch(authError(error)))
  }
}

export const userLoggedIn = (token, clients) => {
  localStorage.setItem('jwtToken', token);
  const decoded = jwtDecode(token)
  return ({
    type: USER_LOGGED,
    decoded: decoded,
    token: token,
    clients: clients
  })
}

export const disconnect = () => {
  localStorage.clear();
  return ({
    type: UNAUTORIZED_ACCES
  })
}


export const authError = (error) => {
  return ({
    type: AUTH_ERROR,
    error: error
  })
}

export const setCurrentClient = (clientid) => (dispatch, getState) => {
  const initialized = getState().server.initialized;
  const url = getState().server.authUrl + '/switchClient';
  const headers = new Headers();
  headers.append('Content-Type', 'application/json')
  headers.append('authorization', 'Bearer ' + getState().authentication.JWTToken)
  if (initialized) {
    return fetch(url, {
      method: 'post',
      headers: headers,
      body: JSON.stringify({ numclient: clientid })

    })
      .then(response => {
        if (response.status === 200)
          return response.json()
        if (response.status === 401 || response.status === 403 || response.status === 500) {
          dispatch(unauthorizedAccess())
          throw new Error('handled')
        }
      })
      .then(json => {
        if (json.token === undefined) {
          dispatch(disconnect())
        } else {
          let token = json.token;

          dispatch(CurrentClientChanged(token));
          //dispatch(onTokenReceived(token));
        }
      })
      .catch((error) => dispatch(authError(error)))
  }

}


export const CurrentClientChanged = (token) => {
  localStorage.setItem('jwtToken', token);
  const decoded = jwtDecode(token)

  return ({
    type: SET_ACTIVE_CLIENT,
    decoded: decoded,
    token: token
  })
}


export const unauthorizedAccess = () => {
  return ({
    type: UNAUTORIZED_ACCES
  })
}